import type { IUserProfileRecentlyWatchedOffer as IUserProfileRecentlyWatchedOfferDto } from '../../../repositories/chats/entities/user_profile/UserProfileRecentlyWatchedOffer';
import type { IUserProfileRecentlyWatchedOffer } from '../../../types/userProfile';

export const mapRecentlyWatchedOffer = (
  offer: IUserProfileRecentlyWatchedOfferDto,
): IUserProfileRecentlyWatchedOffer => {
  const { id, url, price, specs, location, webImageUrl } = offer;

  return {
    id,
    url: url || undefined,
    price: price || undefined,
    specs: specs || undefined,
    location: location || undefined,
    imageUrl: webImageUrl || '',
  };
};
